import React from 'react'
import VehicleClass from '../models/VehicleClass.js';
import {Row, Col, Button} from 'react-bootstrap';
import SCR from '../components/SCR.js';

export default class RentalList extends React.Component {
  constructor(props){
    super(props);

    // call bind to use this in function
    this.handleClick = this.handleClick.bind(this);
    this.isCurrentSelection = this.isCurrentSelection.bind(this);
  }

  componentDidUpdate() {
    //console.log('RentalList UPDATING')
    SCR.resizeParent();
  }

  handleClick(e){
    e.preventDefault();

    var self = this;

    var arr = e.target.value.split('|');
    var vehicleClass = new VehicleClass();
    var rateId = arr[1];
    var vehClass = arr[0];
    var modelDesc = arr[2];
    var totalCharges = parseFloat(arr[3]);

    vehicleClass.setClass(vehClass);
    vehicleClass.setRateId(rateId);
    vehicleClass.setModelDesc(modelDesc);
    vehicleClass.setTotalCharges(totalCharges)

    if(this.props.vehicleClass.isUpgrade && vehClass === this.props.vehicleClass.classCode)
      vehicleClass.setIsUpgrade(true);
    else
      vehicleClass.setIsUpgrade(false);

    // calls set list in step 2
    //self.props.setUpgradeList(totalCharges);
    self.props.setVehicleClass(vehicleClass);
  }

  isCurrentSelection(rateId, classCode){
    //console.log(this.props.isModifyRez)
    //console.log(this.props.vehicleClass.classCode + ' ' + classCode)
    if(!this.props.isModifyRez && this.props.vehicleClass.rateId === rateId)
      return 'current-selection';
    else if(this.props.isModifyRez && this.props.vehicleClass.classCode === classCode)
      return 'current-reservation';
  }

  render() {
    var rentalList = [];

    if(typeof this.props.rentalList !== 'undefined')
      rentalList = this.props.rentalList;

    if(rentalList.length > 0){
      return (
          rentalList.map(
            (rental, index) =>
              <Row xs={1} sm={3} key={rental.rateID} className={'mt-2 ' + this.isCurrentSelection(rental.rateID, rental.classCode) /*this.props.vehicleClass.rateId === rental.rateID ? currentClass : ''*/}>
                <Col>
                  <img className="img-fluid" src={'reservation/' + rental.classImageURL.toLowerCase()} alt={rental.modelDesc} />
                </Col>
                <Col>
                  {rental.modelDesc}<br/>{rental.classDesc}<br/>
                  {rental.freeMiles === '0' ? <><b>Free Miles</b>: Unlimited<br/></> : ''}
                  <b>Seats</b> : {rental.passengers}<br/>
                </Col>

                <Col>
                  <b>{rental.ratePlan}</b>: ${rental.rateAmount}<br/>
                  <b>Estimated Total</b> : ${rental.totalPricing.totalCharges} (Taxes/Surcharges Inc.)<br/>

                  <Button className="reserve-button mt-3 mb-2 ml-0" value={rental.classCode + '|' + rental.rateID + '|' + rental.modelDesc + '|' + rental.totalPricing.totalCharges} onClick={this.handleClick} /*disabled={this.props.vehicleClass.rateId === rental.rateID ? true : false}*/ >Reserve</Button>
                </Col>
              </Row>
          )
      )
    }else{
      return (
        <Row><Col className="text-center border m-3 p-3">No Results found for the dates you selected. Please revise your search.</Col></Row>
      )
    }
  }
}
